// src/components/activityList1.js
import React, { useEffect, useState, useContext } from "react";
import { getActList, deleteActivity } from "../api";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";

const ActivityList1 = ({ id_c }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loadingDel, setLoadingDel] = useState(false);
  const navigate = useNavigate();

  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");
  const [filterMachine, setFilterMachine] = useState("");

  const toYMDdot = (s) => (s ? `${s.slice(0, 7)}.${s.slice(8, 10)}` : "");

  const fetchData = async () => {
    try {
      if (!id_c) return;
      const result = await getActList(id_c);
      setData(result);
    } catch (err) {
      setError(t("errorLoading") || "Error cargando actividades");
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id_c]);

  const handleEdit = (id) => navigate(`/edit_activity/${id}`);

  const handleDelete = async (id) => {
    if (!window.confirm(t("confirmDelete") || "¿Eliminar esta actividad? Esta acción no se puede deshacer.")) return;
    try {
      setLoadingDel(true);
      await deleteActivity(id_c, id);
      setData((prev) => {
        if (!prev) return prev;
        const filtered = (prev.activities || []).filter((r) => r.id !== id);
        return { activities: filtered, total: filtered.length };
      });
    } catch (err) {
      console.error("❌ Error deleting activity:", err);
      alert(t("deleteError") || "No se pudo eliminar. Revisa la consola del servidor.");
    } finally {
      setLoadingDel(false);
    }
  };

  if (error) return <p>{error}</p>;
  if (!data) return <p>{t("MList1") || "Loading..."}</p>;

  const fMach = (filterMachine || "").trim().toLowerCase();

  const activities = (data.activities || []).filter((row) => {
    const dateStr = (row.date_act || "").slice(0, 10); // YYYY-MM-DD
    const machStr = (row.cod_maq || "").toLowerCase();

    if (filterDateFrom && dateStr < filterDateFrom) return false;
    if (filterDateTo   && dateStr > filterDateTo)   return false;
    return machStr.startsWith(fMach);
  });

  return (
    <div className="box1">
      <div className="box9">
        <button className="button7" onClick={() => navigate("/new_activity")}>
          {t("actType5")}
        </button>

        {/* Filtro de fechas */}
        <div style={{ clear: "both", width: "100%", display: "flex", justifyContent: "center", padding: "6px 0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span className="text3" style={{ whiteSpace: "nowrap" }}>{t("atr_dateFrom")}</span>
            <input
              type="date"
              value={filterDateFrom}
              onChange={(e) => setFilterDateFrom(e.target.value)}
            />
            <span className="text3" style={{ whiteSpace: "nowrap" }}>{t("atr_dateTo")}</span>
            <input
              type="date"
              value={filterDateTo}
              onChange={(e) => setFilterDateTo(e.target.value)}
            />
            {(filterDateFrom || filterDateTo) && (
              <button
                className="button8"
                onClick={() => { setFilterDateFrom(""); setFilterDateTo(""); }}
                style={{ whiteSpace: "nowrap", width: "auto" }}
              >
                ✕ {t("atr_all")}
              </button>
            )}
          </div>
        </div>

        {/* Filtro de texto */}
        <div className="table5">
          <input
            type="text"
            placeholder="🔎 Filtrar por máquina"
            value={filterMachine}
            onChange={(e) => setFilterMachine(e.target.value)}
            style={{ width: "45%", float: "left" }}
          />
        </div>

        <table className="table5">
          <thead>
            <tr>
              <th>{t("oper7") /* Fecha */}</th>
              <th>{t("actType2") || "Actividad"}</th>
              <th>{t("batchList2") /* Máquina */}</th>
              <th>{t("batchList3") || "Producto"}</th>
              <th>{t("batchList8") || "Hora Inicio"}</th>
              <th>{t("batchList10") || "Hora Fin"}</th>
              <th>{t("actType4") || "Observaciones"}</th>
              <th>{t("MList7") || "Editar"}</th>
              <th>{t("MList8") || "Borrar"}</th>
            </tr>
          </thead>
          <tbody>
            {activities.map((row) => (
              <tr key={row.id}>
                <td>{toYMDdot((row.date_act || "").slice(0, 10)) || "-"}</td>
                <td>{row.id_activity}</td>
                <td>{row.cod_maq ?? "-"}</td>
                <td>{row.id_prod ?? "-"}</td>
                <td>{row.time_begin ? row.time_begin.slice(0, 5) : "-"}</td>
                <td>{row.time_end ? row.time_end.slice(0, 5) : "-"}</td>
                <td>{row.observations ?? "-"}</td>
                <td>
                  <button className="button" onClick={() => handleEdit(row.id)}>
                    {t("MList7") || "Editar"}
                  </button>
                </td>
                <td>
                  <button
                    className="buttonDel"
                    disabled={loadingDel}
                    onClick={() => handleDelete(row.id)}
                  >
                    {t("MList8") || "Borrar"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default ActivityList1;
